// extracted by mini-css-extract-plugin
export default {"outer":"account_outer__tLgRn","who":"account_who__qhuyN","name":"account_name__+T88-","avatarLink":"account_avatarLink__1HVMJ","manageAccounts":"account_manageAccounts__8EmDo"};